import { Button, Typography } from '@mui/material';
import { useStyles } from 'components/Styles';
import React from 'react';

export default function WelcomeText(props) {
  const { setStep } = props;
  const classes = useStyles();

  return (
    <>
      <Typography
        style={{ marginBottom: '1rem', fontWeight: '700', fontSize: '38px' }}
      >
        Olá, seja <span style={{ color: '#00C051' }}>bem-vindo</span>!
      </Typography>
      <Typography
        style={{ textAlign: 'center', marginInline: '2rem', fontSize: '22px' }}
      >
        Vamos configurar a sua fazenda para que você possa iniciar a utilização
        da plataforma já com os principais dados cadastrados.
      </Typography>
      <Button
        className={classes.roundedButton}
        style={{ width: '50%', marginTop: '2rem' }}
        variant="contained"
        size="large"
        onClick={() => {
          setStep((prev) => prev + 1);
        }}
      >
        <Typography variant="button" style={{ textTransform: 'none' }}>
          Criar uma fazenda
        </Typography>
      </Button>
    </>
  );
}
